<!--
 * @Author: guoyu
 * @Date: 2021-05-13 15:41:18
 * @LastEditors: your name
 * @LastEditTime: 2021-05-14 14:41:18
 * @Description: 一个简单的弹窗组件
-->
<template>
  <div class="over-lay" v-show="show" @click="layClose">
    <div class="content" @click.stop>
      <i class="el-icon-close close-icon" v-if="defaultClose" @click="close"></i>
      <slot :close="close"> </slot>
    </div>
  </div>
</template>
<script>
export default {
  model: {
    event: 'change',
    prop: 'show'
  },
  props: {
    // 点击罩层关闭
    overlayClose: {
      type: Boolean,
      default: true
    },
    show: {
      type: Boolean,
      default: false
    },
    // 使用默认关闭按钮
    defaultClose: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    layClose() {
      if (!this.overlayClose) return;
      this.close()
    },
    close() {
      this.$emit('close', false);
      this.$emit('change', false);
      this.$emit('destroy');
    }
  }
};
</script>
<style scoped>
.over-lay {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.3);
}
.content {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.close-icon {
  position: absolute;
  top: 20px;
  right: 20px;
  font-size: 15px;
  font-weight: 700;
  color: #999999;
  cursor: pointer;
}
</style>
